<div class="api-card api-card--full">
  <div class="api-card__header">
    <div class="api-card__header-stack">
      <span class="api-card__title">Platform</span>
      <span class="api-card__desc">Right now, not limited to the window.</span>
    </div>
  </div>

  <dl class="overview-figures">
    <div class="overview-figure">
      <dt class="overview-figure__label">Organizations</dt>
      <dd class="overview-figure__value">{{ platform.organizations | number }}</dd>
      <dd class="overview-figure__note">
        {{ platform.billingExemptOrganizations | number }} billing-exempt · {{ platform.focusOrganizations | number }} FOCUS
      </dd>
    </div>
    <div class="overview-figure">
      <dt class="overview-figure__label">Users</dt>
      <dd class="overview-figure__value">{{ platform.users | number }}</dd>
      <dd class="overview-figure__note">{{ platform.superadmins | number }} superadmin{{ platform.superadmins === 1 ? '' : 's' }}</dd>
    </div>
    <div class="overview-figure">
      <dt class="overview-figure__label">Active API keys</dt>
      <dd class="overview-figure__value">{{ platform.activeApiKeys | number }}</dd>
    </div>
    <div class="overview-figure">
      <dt class="overview-figure__label">Wallet balance</dt>
      <dd class="overview-figure__value">{{ wallets.balanceCents | money }} {{ wallets.currency | uppercase }}</dd>
      <dd class="overview-figure__note">
        Across every wallet
        @if (wallets.negativeBalances > 0) {
          · <a routerLink="/admin/organizations" class="overview-figure__alert">{{ wallets.negativeBalances | number }} in debt</a>
        }
      </dd>
    </div>
  </dl>
</div>
